import React from 'react';
import Navigation from '../../components/navigation';
import Banner from '../../components/banner';
import Footer from '../../components/footer';
import picLogo from '../../public/images/index/index-logo.png';
import picText from '../../public/images/index/index-text.png';
import picInfo from '../../public/images/index/index-info.png';

function App() {
  // 导航配置
  return (
    <div className="app">
      <Navigation active={0} />
      <Banner />
      <div className="main-container">
        <div className="main-inner">
          <img className={'pic-logo'} src={picLogo} alt="" />
          <div className="comp-text">
                      <p>云天化集团是以肥料产业、玻纤及复合材料、化工新材料为主业的综合性产业集团，是全球领先的磷肥、氮肥、玻纤、共聚甲醛制造商。
          集团资产总额超1000亿元，2025年集团实现营收765亿元，利润总额66亿元，保持稳定向好的发展势头，跑赢市场和同行。位列中国企业500强第304位、中国制造业企业500强第159位。</p>
                    </div>
          <img className={'pic-info'} src={picInfo} alt="" />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;